import { useState, useEffect, useContext, forwardRef, useImperativeHandle, useRef  } from "react"
import { Dialog, DialogActions  } from '@mui/material';
import { CcActionButton } from "../commonComponents/styledTexts";
import { LionListbox} from '../commonComponents/inputFields'
import { Icon as Iconify } from '@iconify/react';


export const GoogleFontsSelector = (props) => {
  const [selectedFont, setSelectedFont] = useState('')
  const [foundFonts, setFoundFonts] = useState([])
  const [searchedAndSelectedFonts, setSearchedAndSelectedFonts] = useState([])

  useEffect(() => {
    if (props.fonts === undefined || props.fonts.length === 0) return;

    if (props.selected && props.selected.length > 0) setSelectedFont(props.selected)
    else setSelectedFont(props.fonts[0].id)
  }, [props.selected, props.fonts])

  const handleChangeFont = (fName) => {
    setSelectedFont(fName)
    if (props.onChange) props.onChange(fName)
  }

  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const handleClosePreviewDialog = () => {
    setOpenPreviewDialog(false)
  }

  const handleSearchChange = (e) => {
    const word = e.target.value
    if (word.length === 0) {
      setFoundFonts([])
      return;
    }
    const matches = props.fonts.filter(f => f.family.toLowerCase().includes(word)).slice(0, 50);
    setFoundFonts(matches)
  }
  const handleSearchSelectedFont = (fname) => {
    const newSearchedFonts = [...searchedAndSelectedFonts, {id: fname, name: fname, family: fname}]
    setSearchedAndSelectedFonts(newSearchedFonts)
    setSelectedFont(fname)
    if (props.onChange) props.onChange(fname)
    setOpenPreviewDialog(false)

  }

  return  <div className='flex flex-row items-center'>
            <img src='/assets/popularBadge.png' className='mt-2' width={58} height={58} alt='' />
            <div className='w-52'>
            <div htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
            {props.displayName}
            </div>

              <LionListbox 
                items={props.fonts.slice(0, 5).concat(searchedAndSelectedFonts).map(f => {return {id: f.family, name: f.family}})} 
                zIndex={props.zIndex ? props.zIndex : 1000}
                selectedItemId={selectedFont} 
                onChange={(item) => handleChangeFont(item.id)}
                />
            </div>
            <div className='ml-1 mt-[22px] cursor-pointer' onClick={() => setOpenPreviewDialog(true)}><Iconify icon="material-symbols:search" width={32} /></div>
    
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openPreviewDialog}
        onClose={handleClosePreviewDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className='p-4 h-[800px] overflow-auto'>
        <input
            className="block w-full rounded-md border-0 py-8 px-5 text-6xl text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-ccColorDarkTeal placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-inset focus:ring-ccColorTeal"
            onChange={handleSearchChange}
            //onKeyDown={handleSearchChange}
            //value={inputValue}
            placeholder="start typing..."
          />
        <div className='mt-4 text-ccColorDarkTeal flex flex-col gap-y-2'>
          {foundFonts.map(f => <div className='bg-slate-100 p-2 rounded w-96 flex flex-row items-center'>
            <div className='font-bold text-2xl'>{f.family}</div>
            <div className='flex grow'></div>
            <CcActionButton onClick={() => handleSearchSelectedFont(f.family)}>Select</CcActionButton>
            </div>)
          }
        </div>
        </div>
        <DialogActions>
          <CcActionButton className='mr-2 mb-2' onClick={handleClosePreviewDialog}>Close</CcActionButton>
        </DialogActions>
      </Dialog>


  </div>
}
